const initialState = {
  data: [],
  loading: true,
  cache: {},
};

export const GetAllGeneralPay = (state = initialState, action) => {
  switch (action.type) {
    case "get_allgeneralpay":
      return {
        ...state,
        data: action.payload,
        loading: action.loader ?? false,
        cache: action.cacheKey
          ? { ...state.cache, [action.cacheKey]: action.payload }
          : state.cache,
      };

    case "set_loading_generalpay":
      return {
        ...state,
        loading: action.payload,
      };

    case "clear_generalpay_cache":
      return {
        ...state,
        cache: {},
      };

    default:
      return state;
  }
};
